export const tierGroupNamesByProductType = {
  APP: ['CRM', 'OPERATIONS', 'MARKETING', 'SALES', 'SERVICE', 'CONTENT'],
  THEME: ['CRM', 'CONTENT', 'MARKETING', 'OPERATIONS', 'SALES', 'SERVICE'],
  MODULE: ['CRM', 'CONTENT', 'MARKETING', 'OPERATIONS', 'SALES', 'SERVICE']
};